import { render, staticRenderFns } from "./HeatmapReport.vue?vue&type=template&id=d6ecd1d6"
import script from "./HeatmapReport.vue?vue&type=script&lang=js"
export * from "./HeatmapReport.vue?vue&type=script&lang=js"
import style0 from "./HeatmapReport.vue?vue&type=style&index=0&id=d6ecd1d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports